import script from "./SettingsExecutivesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsExecutivesSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsExecutivesSection.vue?vue&type=style&index=0&id=54bd565c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54bd565c"]])

export default __exports__